import { EyeIcon, TrendUpIcon } from '@airship-platform/jam-web/icons';
import Chip from '@mui/material/Chip';
import Skeleton from '@mui/material/Skeleton';
import {
  type AggregatedOptionActivity,
  metricLabel,
  type ProposalEngagement,
} from '../../../../data-access/proposalEngagement';

const NOT_OPENED_MESSAGE = 'Customer has not opened the proposal yet';
const UNNAMED_OPTION = 'Unnamed option';

const TREND_ICON = <TrendUpIcon width={14} height={14} />;
const EYE_ICON = <EyeIcon width={14} height={14} />;

interface OwnProps {
  isLoading: boolean;
  engagement?: ProposalEngagement;
  standout?: AggregatedOptionActivity;
  optionName: (optionGuid: string | null) => string | undefined;
}

const bannerContentOf = ({
  isLoading,
  engagement,
  standout,
  optionName,
}: OwnProps) => {
  if (isLoading) {
    return { icon: TREND_ICON, label: <Skeleton width={240} /> };
  }

  if (!engagement) {
    return { icon: EYE_ICON, label: NOT_OPENED_MESSAGE };
  }

  if (!standout) {
    return null;
  }

  return {
    icon: TREND_ICON,
    label: `Top engaged option: ${
      optionName(standout.optionGuid) ?? UNNAMED_OPTION
    } (${metricLabel(standout)})`,
  };
};

const EngagementBanner: React.FC<OwnProps> = (props) => {
  const content = bannerContentOf(props);

  if (!content) {
    return null;
  }

  return (
    <Chip
      size={'small'}
      color={'softGold'}
      icon={content.icon}
      label={content.label}
      sx={{ width: '100%', justifyContent: 'center' }}
    />
  );
};

export default EngagementBanner;
